import {Component} from '@angular/core';

import {Observable} from 'rxjs';

import {Notification} from './notification';
import {NotificationsService} from './notifications.service';

@Component({
    selector: 'notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent {

    private _notifications: Notification[] = [];

    get notifications(): Notification[] {
        return this._notifications.filter(notification => !notification.isClosed);
    }

    get hasNotifications(): boolean {
        return this.notifications && this.notifications.length > 0;
    }

    get hasUnreadNotifications(): boolean {
        return this.notifications.some(notification => !notification.isRead);
    }

    constructor(private _notificationsService: NotificationsService) {
        this._notificationsService
            .getNotifications()
            .subscribe(notifications => this._notifications = notifications);
    }

    markAllNotificationsAsRead(): void {
        this._notificationsService.markAsRead(this.notifications);
    }

    closeNotification(notification: Notification) {
        this._notificationsService.close(notification);
    }
}